(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/statistics/assets/javascripts/models/draws.js') >= 0) return;  svs.modules.push('/components/statistics/statistics/assets/javascripts/models/draws.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs = svs || {};
  svs.statistics = svs.statistics || {};
  svs.statistics.models = svs.statistics.models || {};

  var DrawsModel = _.extend({}, svs.statistics.mixins.SocketSubscriber, {
    url: function() {
      return svs.core.jupiter.url() + (this.socketResourcePath || '');
    },

    initialize: function(options) {
      options = options || {};

      this.logger = new svs.core.log.Logger('svs.statistics.models.Draws');

      this.socketResourcePath =
        '/sport/1/matches/' + this.get('matchId') + '/draws';

      if (options.subscribe) {
        this.startPush();
      }

      if (options.fetch) {
        this.fetch();
      }
    },

    onSocketUpdate: function(param) {
      if (!_.isObject(param) && param.length === 0) {
        param = {};
      }
      param.matchId = this.get('matchId');

      if (svs.statistics && svs.statistics.socketCache) {
        svs.statistics.socketCache.add('MATCH_DRAWS', param);
      }

      this.set(this.parse(param));
    },

    startPush: function() {
      this.subscribe(this.socketResourcePath, this.onSocketUpdate, true);
    },

    stopPush: function() {
      this.unsubscribe();
    },

    getDraws: function() {
      if (
        this.get('drawInfo') &&
        _.isObject(this.get('drawInfo').oddsetDraws)
      ) {
        return this.get('drawInfo').oddsetDraws;
      }

      return false;
    },

    getCurrent: function() {
      if (
        this.get('drawInfo') &&
        _.isObject(this.get('drawInfo').currentDraws)
      ) {
        return this.get('drawInfo').currentDraws;
      }

      return false;
    }
  });

  svs.statistics.models.Draws = Backbone.Model.extend(DrawsModel);
})(Backbone, _, svs);

 })(window);